import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { ErrorScreen } from '@/components/layout/ErrorScreen';
import { HomePage } from '@/pages/Home';
import { GamesPage } from '@/pages/Games';
import { DesignSystemPage } from '@/pages/DesignSystem';
import { ProfilePage } from '@/pages/Profile';
import { PublicProfilePage } from '@/pages/PublicProfile';
import { FriendsPage } from '@/pages/Friends';
import { ProgressionPage } from '@/pages/Progression';
import { LobbyPage } from '@/pages/Lobby';
import { GamePage } from '@/pages/Game';
import { LeaderboardPage } from '@/pages/Leaderboard';
import { AchievementsPage } from '@/pages/Achievements';
import { CosmeticsPage } from '@/pages/Cosmetics';
import { BattlePassPage } from '@/pages/BattlePass';
import { PublicScorePage } from '@/pages/PublicScore';
/**
 * Routes principales. Les pages encore non implémentées affichent un
 * PlaceholderPage explicite (avec n° d'étape du mega-prompt) plutôt qu'un
 * écran vide — règle ergonomique posée à l'étape 1.
 */
export const router = createBrowserRouter([
    // ── Pages publiques (hors AppLayout, accessibles sans auth) ────────────
    // /score/:id est le point d'entrée des liens partagés sur les réseaux.
    {
        path: '/score/:id',
        element: _jsx(PublicScorePage, {}),
        errorElement: _jsx(ErrorScreen, {}),
    },
    // ── App principale ─────────────────────────────────────────────────────
    {
        path: '/',
        element: _jsx(AppLayout, {}),
        errorElement: _jsx(ErrorScreen, {}),
        children: [
            { index: true, element: _jsx(HomePage, {}) },
            { path: 'games', element: _jsx(GamesPage, {}) },
            { path: 'design-system', element: _jsx(DesignSystemPage, {}) },
            // ── Étape 3 ────────────────────────────────────────────────────
            { path: 'profile', element: _jsx(ProfilePage, {}) },
            { path: 'profile/:pseudo', element: _jsx(PublicProfilePage, {}) },
            { path: 'friends', element: _jsx(FriendsPage, {}) },
            { path: 'progression', element: _jsx(ProgressionPage, {}) },
            // ── Étape 4 ────────────────────────────────────────────────────
            { path: 'lobby/:code', element: _jsx(LobbyPage, {}) },
            // ── Étape 5 ────────────────────────────────────────────────────
            { path: 'game/:id', element: _jsx(GamePage, {}) },
            // ── Étape 7 ────────────────────────────────────────────────────
            { path: 'leaderboard', element: _jsx(LeaderboardPage, {}) },
            // ── Étape 8 ────────────────────────────────────────────────────
            { path: 'achievements', element: _jsx(AchievementsPage, {}) },
            // ── Étape 10 ───────────────────────────────────────────────────
            { path: 'cosmetics', element: _jsx(CosmeticsPage, {}) },
            // ── Étape 11 ───────────────────────────────────────────────────
            { path: 'battle-pass', element: _jsx(BattlePassPage, {}) },
            // 404
            { path: '*', element: _jsx(Navigate, { to: "/", replace: true }) },
        ],
    },
]);
